import { Permissions } from 'app/constants/permissions'

/** Kolejność uprawnień na pigułkach - przeniesiona 1:1 ze starej zakładki. */
export const PERMISSIONS = [
  Permissions.canCreateCompany,
  Permissions.canEditCompany,
  Permissions.canRemoveCompany,
  Permissions.canCreateUser,
  Permissions.canEditUser,
  Permissions.canRemoveUser,
  Permissions.canViewConfiguration,
  Permissions.canImportFiles,
  Permissions.canExportData,
  Permissions.canAddDriver,
  Permissions.canViewActivities,
  Permissions.canEditActivities,
  Permissions.canViewBillingData,
  Permissions.canEditBillingData,
  Permissions.canViewDelegations,
  Permissions.canEditDelegations,
  Permissions.canViewAlerts,
  Permissions.canEditAlerts,
  Permissions.canEditGpsData,
  Permissions.canEditActivityDay,
  Permissions.canReadDatabaseLogin,
  Permissions.canGenerateAttestation,
  Permissions.canGeneratePrintouts,
  Permissions.isDriver,
]

export const PERMISSION_COLORS: Record<string, string> = {
  canViewActivities: '#2B2E33',
  canEditActivities: '#89A2A5',
  isDriver: '#FF6A88',
  canViewBillingData: '#AA6A88',
  canEditBillingData: '#A8A85F',
  canEditCompany: '#267F00',
  canRemoveCompany: '#FFD800',
  canViewDelegations: '#808080',
  canEditDelegations: '#0094FF',
  canAddDriver: '#004A7F',
  canCreateCompany: '#7F6A00',
  canImportFiles: '#7C657A',
  canReadDatabaseLogin: '#FF6A00',
  canCreateUser: '#7F0000',
  canEditUser: '#FF006E',
  canRemoveUser: '#007F7F',
  canViewConfiguration: '#000',
  canViewAlerts: '#FFA36B',
  canEditAlerts: '#A75BFF',
  canEditGpsData: '#FF9A47',
  canEditActivityDay: '#AC7FFF',
  canGenerateAttestation: '#0072FF',
  canGeneratePrintouts: '#FF7519',
  canExportData: '#7F6A00',
}
